module.exports = __webpack_public_path__ + "res/Roboto-CondensedItalic-webfont.svg?337b005d739562042a94a9b48ae4854b";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-CondensedItalic-webfont.svg
// module id = 45
// module chunks = 0